import React from 'react'
import { Button } from '@mui/material'
import ReaOnlyOutlinedInput from '../../input/ReaOnlyOutlinedInput'

const BidMastaInputForm = ({ mastaName, handleClick, inputRef, inputId, nameValue, handleChangeName, handleClickName }) => {
    return (
        <>
            <div style={{display:'flex'}}>
                <Button color="primary" size="large" variant="contained"
                    sx={{ fontSize: '14px', height:'38px', width:'80px' }}
                    onClick={ handleClick }
                    >{ mastaName }
                </Button> 
            </div>
            <div style={{display:'flex', marginLeft:'5px'}}>
                <ReaOnlyOutlinedInput type="text" id={ inputId } inputRef={ inputRef } label={ mastaName } value= { nameValue } onChange={handleChangeName} onClick={handleClickName} width="300px" />
            </div>
        </>
    );
}

export default BidMastaInputForm